<template>
  <div class="add-service">
    <!-- <div class="add-service" :style="{ paddingTop: `${statusBarH}px` }"> -->
    <!-- <div class="nav" :style="{ height: `${statusBarH}px`,top:'0px' }"></div> -->
    <div class="top">
      <!-- <img class="left" src="./img/left.png" @click="handleLeft"><br> -->
      <img class="font1" style="width:96px;height:25px" src="./img/font.png">
      <div class="text">三月服务月赋能商户经营</div>

      <div class="info">
        <img class="info-img" :src="storeInfo.storeLogo || require('./img/img_logo.png')">
        <div class="info-name">
          <div class="info-title">{{ storeInfo.storeName }}</div>
          <div class="info-address">{{ storeInfo.plazaName }}{{ storeInfo.floor }}-{{ storeInfo.bunkDesc }}</div>
        </div>
        <div class="people-line">
          <img class="people" src="./img/img_people.png">
        </div>
      </div>
      <div class="font2">优质服务</div>

      <div class="icons">
        <div class="icon-item">
          <img src="./img/icon1.png">
          <span>服务权益</span>
        </div>
        <img class="icon-add" src="./img/icon5.png">
        <div class="icon-item">
          <img src="./img/icon2.png">
          <span>用电安全</span>
        </div>
        <img class="icon-add" src="./img/icon5.png">
        <div class="icon-item">
          <img src="./img/icon3.png">
          <span>空调舒适度</span>
        </div>
        <img class="icon-add" src="./img/icon5.png">
        <div class="icon-item">
          <img src="./img/icon4.png">
          <span>铺内清洁</span>
        </div>
      </div>
    </div>
    <div class="bottom" :style="{ paddingBottom: isSubmit ? '0px' : '110px', background: isSubmit ? '#fff' : '' }">
      <img class="flag" src="./img/icon6.png">

      <template v-if="isSubmit">
        <div class="success">
          <img class="success-icon" src="./img/icon_success.png">
          <div class="success-title">您已提交</div>
          <div class="success-txt">请前去查看详情</div>
          <van-button class="success-btn" type="primary" round @click="handleDetail"
            color="#FF6F00">查看详情</van-button>
        </div>

      </template>
      <template v-else>

        <div class="bottom-top">
          <div class="bottom-title">选择增值服务</div>
          <div class="bottom-notice">服务包选1个，包内服务可多选</div>
        </div>
        <van-collapse class="ul" v-model="activeNames">
          <van-collapse-item v-for="(item, itemIndex) in list" :title="item.name" :name="item.packageId"
            :key="item.packageId">
            <div class="li" style="border-top: 1px solid #f5f5f5;" v-for="(checkItem, checkIndex) in item.list"
              @click="handleClick(itemIndex, checkIndex, checkItem)" :key="checkItem.id">
              <span>{{ checkItem.item }}</span>
              <van-checkbox :value="checkItem.checked">
                <template #icon="props">
                  <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                </template>
              </van-checkbox>
            </div>
          </van-collapse-item>
        </van-collapse>

      </template>


    </div>


    <div class="footer" v-if="!isSubmit">
      <van-button :loading="loading" :disabled="!checkedListLength" class="submit" type="primary" round
        @click="handleSubmit" color="#FF6F00">提交</van-button>
    </div>


    <van-popup v-model="showPopup" round position="bottom" :style="{ minHeight: '30%' }">
      <div class="content">
        <div class="content-title">
          <span>已选服务包</span>
          <img src="./img/icon_closed.png" @click="showPopup = false">
        </div>

        <div class="package-name">{{ packageName }}</div>


        <div class="packages" v-if="checkedListLength == 1" style="justify-content: center;">
          <div class="checked-item" v-for="checked in checkedList" :key="checked.id">
            <img src="./img/checked.png">
            <span>{{ checked.item }}</span>
          </div>
        </div>

        <div class="packages" v-else>
          <div class="checked-item" v-for="checked in checkedList" :key="checked.id">
            <img src="./img/checked.png">
            <span>{{ checked.item }}</span>
          </div>
        </div>

        <div style="text-align: center;margin-top: 20px;">
          <van-button :loading="loading" class="re-submit" type="primary" round @click="reHandleSubmit"
            color="#FF6F00">确定</van-button>
        </div>



      </div>
    </van-popup>


  </div>
</template>

<script>
import { Collapse, CollapseItem, Checkbox, Button, Popup } from 'vant';
import { apiGetApplied, apiGetItem, apiSubmitService } from '@/api/addService';
import { apiGetStore } from '@/api/insurance';

export default {
  components: {
    VanCollapse: Collapse,
    VanCollapseItem: CollapseItem,
    VanCheckbox: Checkbox,
    VanButton: Button,
    VanPopup: Popup
  },
  computed: {
    checkedListLength() {
      return this.checkedList.length
    }
  },
  watch: {},

  data() {
    return {
      statusBarH: 0,
      storeLogo: '',
      storeInfo: {},
      list: [],
      activeNames: [],
      lastActive: 0,
      checkedList: [],
      activeIcon: require('./img/checked.png'),
      inactiveIcon: require('./img/checked_no.png'),
      isSubmit: false,
      submitId: false,
      loading: false,
      packageId: '',
      packageName: '',
      showPopup: false
    };
  },
  methods: {
    handleClick(itemIndex, checkIndex, item) {
      this.packageId = this.list[itemIndex].packageId
      this.packageName = this.list[itemIndex].name
      item.checked = !item.checked
      this.$set(this.list[itemIndex].list, checkIndex, item)
      let list = JSON.parse(JSON.stringify(this.list))
      if (itemIndex != this.lastActive) {
        list.forEach((item1, index1) => {
          if (itemIndex != index1) {
            item1.list.forEach((item2, index2) => {
              item2.checked = false
            })
            this.$set(this.list, index1, item1)
          }
        })
      }
      this.lastActive = itemIndex

      this.checkedList = []
      this.list.forEach(item1 => {
        item1.list.forEach(item2 => {
          if (item2.checked) {
            this.checkedList.push(item2)
          }
        })
      })
    },
    handleSubmit() {
      this.showPopup = true
    },
    reHandleSubmit() {
      let submitService = this.checkedList.map(item => item.id).join(',')
      let data = {
        plazaName: this.$store.state.account.plazaName,
        storeId: this.$store.state.account.storeId,
        storeName: this.$store.state.base.storeName,
        userName: this.$store.state.account.name,
        submitService: submitService,
        packageId: this.packageId
      }
      this.loading = true
      apiSubmitService(data).then(res => {
        this.loading = false
        this.isSubmit = true
        this.submitId = res.id
        this.showPopup = false
        this.$bsUtils.nativeApi.jumpPage('wdmp://mp.wanda.cn/freeServiceApplyDetailPage?id=' + res.id)
      }).catch(() => {
        this.loading = false
      })
      // this.$bsUtils.nativeApi.jumpPage('wdmp://mp.wanda.cn/freeServiceApplyDetailPage?id=123')

    },
    getStoreList() {
      apiGetStore(this.$store.state.account.userId).then((list) => {
        this.storeInfo = list.find(store => store.storeId == this.$store.state.account.storeId)
      });
    },
    handleLeft() {
      this.$bsUtils.nativeApi.goBack();
    },
    handleDetail() {
      this.$bsUtils.nativeApi.jumpPage('wdmp://mp.wanda.cn/freeServiceApplyDetailPage?id=' + this.submitId)
    }
  },
  async mounted() {
    // let { statusBarH } = await this.$bsUtils.nativeApi.getDeviceInfo();
    // this.statusBarH = statusBarH;
    this.getStoreList()
    // this.$store.commit('account/ACCOUNT_USER_ID', 1640218236);
    // this.$store.commit('account/ACCOUNT_STORE_ID', 3078139);
    // this.$store.commit('account/ACCOUNT_PLAZA_ID', 1004326);
    // this.$store.commit('account/ACCOUNT_TOKEN', 'ODM1NTQzNjQ1NTc3ODQyNjg4');
    let res = await apiGetApplied(this.$store.state.account.storeId);
    if (res) {
      // 已提交
      this.isSubmit = true
      this.submitId = res.id
      // this.$bsUtils.nativeApi.goBack()
      // this.$bsUtils.nativeApi.jumpPage('wdmp://mp.wanda.cn/freeServiceApplyDetailPage?id=' + res.id)
      return
    }
    let res2 = await apiGetItem();
    this.list = res2
  },
};
</script>

<style lang="less" scoped>
.add-service {
  line-height: 1;
  text-align: left;
  font-family: PingFangSC-Medium, PingFang SC;
  font-size: 16px;
  box-sizing: border-box;
  overflow: auto;
  padding-bottom: env(safe-area-inset-bottom);
  background-image: url('./img/bg_img.png');
  background-repeat: no-repeat;
  background-size: 100%;
  background-color: #ffffff;

  // .nav {
  //   background-color: #FF3D34;
  //   position: fixed;
  //   z-index: 999;
  //   width: 100%;
  // }

  .top {
    padding: 0 12px;

    // .left {
    //   width: 17px;
    //   height: 17px;
    //   margin-top: 30px;
    // }

    .font1 {
      margin-top: 36px;
    }

    .text {
      font-size: 12px;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.9);
      margin-top: 8px;
    }

    .info {
      background: linear-gradient(180deg, #FFEBE9 0%, #FFFFFF 100%);
      border-radius: 8px;
      padding: 12px;
      display: flex;
      margin-top: 24px;
      position: relative;
      z-index: 9;

      .info-img {
        width: 48px;
        height: 48px;
        border-radius: 4px;
      }

      .info-name {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-left: 12px;

        .info-title {
          font-size: 18px;
          font-weight: 500;
          color: #111111;
        }

        .info-address {
          margin-top: 8px;
          font-size: 12px;
          font-weight: 400;
          color: #999999;
        }
      }

      .people-line {
        position: absolute;
        right: 0;
        top: 0;
        height: 1px;

        .people {
          width: 170px;
          position: absolute;
          right: 0;
          bottom: 1px;
        }
      }
    }

    .font2 {
      font-size: 15px;
      font-weight: 500;
      color: rgba(255, 255, 255, 0.9);
      margin-top: 16px;
    }

    .icons {
      margin-top: 5px;
      display: flex;
      align-items: center;
      justify-content: space-around;

      .icon-item {
        display: flex;
        flex-direction: column;
        align-items: center;

        img {
          width: 40px;
          height: 40px;
        }

        span {
          font-size: 12px;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.9);
          margin-top: 4px;
        }
      }

      .icon-add {
        width: 14px;
        height: 14px;
        margin-bottom: 10px;
      }
    }

  }

  .bottom {
    border-radius: 8px 8px 0 0;
    margin-top: 16px;
    min-height: 230px;
    padding: 20px 12px 300px 12px;
    background-image: linear-gradient(180deg, #FFFFFF 0%, #F3F5F6 100%);
    background-color: #F3F5F6;
    background-size: 100% 200px;
    background-repeat: no-repeat;
    position: relative;

    .flag {
      position: absolute;
      width: 16px;
      height: 11px;
      top: 0px;
      left: 50%;
      transform: translate(-50%, 0);
    }

    .success {
      text-align: center;

      .success-icon {
        width: 64px;
        height: 64px;
        margin-top: 75px;
      }

      .success-title {
        font-family: PingFangSC-Medium, PingFang SC;
        font-size: 18px;
        font-weight: 500;
        color: #111111;
        margin-top: 16px;
      }

      .success-txt {
        font-size: 14px;
        margin-top: 8px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
      }

      .success-btn {
        width: 240px;
        font-size: 18px;
        font-weight: 500;
        color: #FFFFFF;
        margin-top: 48px;
      }
    }

    .bottom-top {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      padding-bottom: 8px;

      .bottom-title {
        font-size: 15px;
        font-weight: 700;
        color: #111111;
      }

      .bottom-notice {
        font-size: 12px;
        font-weight: 400;
        color: #999999;
      }
    }

    .ul {
      margin-top: 4px;
      border-radius: 4px;
      overflow: hidden;
      background-color: transparent;

      /deep/.van-cell {
        padding: 13px 16px;
      }

      /deep/.van-collapse-item--border::after {
        border-top: none;
      }

      .van-collapse-item {
        margin-top: 12px;
        border-radius: 4px;
        overflow: hidden;

        /deep/.van-cell::after {
          border: none;
        }

        /deep/.van-collapse-item__content {
          padding: 0px 16px;
        }

        /deep/.van-cell__title {
          font-size: 15px;
          font-weight: 700;
          color: #111111;
        }

        /deep/.van-cell__right-icon {
          color: #BEBEBE;
        }
      }

      .li {
        font-family: PingFangSC-Regular, PingFang SC;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        font-weight: 400;
        color: #111111;
        padding: 15px 0px;

        .img-icon {
          width: 18px;
          height: 18px;
        }
      }
    }

    /deep/.van-hairline--top-bottom::after {
      border-width: 0;
    }
  }

  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 12px 12px 40px 12px;
    background: #FFFFFF;

    .submit {
      width: 100%;
      height: 44px;
      font-size: 18px;
      font-weight: 500;
      color: #FFFFFF;
    }
  }

  .van-popup {
    .content {
      padding: 20px 20px 40px 20px;

      .content-title {
        display: flex;
        justify-content: space-between;

        span {
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #111111;
        }

        img {
          width: 18px;
          height: 18px;
        }
      }

      .package-name {
        margin-top: 20px;
        background: #F3F5F6;
        border-radius: 4px;
        padding: 12px 0;
        text-align: center;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #111111;
      }

      .packages {
        margin-top: 10px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #111111;
        display: flex;
        flex-wrap: wrap;
        // justify-content: center;

        img {
          width: 14px;
          height: 14px;
          margin-right: 3px;
        }

        .checked-item {
          display: flex;
          align-items: center;
          width: 50%;
          box-sizing: border-box;
          padding: 13px 0 13px 16px;
        }
      }

      .re-submit {
        width: 168px;
        height: 44px;
        text-align: center;

        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 44px;
        margin: 0 auto;
      }


    }
  }


}
</style>